// export const logout = ( state ) => {
// }

export const setRoles = (state, roles) => {
    state.roles = roles
}

export const setRolesSelectable = (state, roles) => {
    state.rolesSelectable = roles
}

export const setRolSelect = ( state, rol ) => {
    state.rolSelect = rol
}


export const setRolesPaginated = (state, rolesPaginatedData) => {
    state.rolesPaginatedData = rolesPaginatedData
}

export const setRolDetail = (state, rol) => {
    state.rol = rol
}

export const saveNewRoles = (state, rol) => {
    state.roles.unshift(rol)
    state.createdData = rol;
}

export const saveUpdatedRol = (state, rol) => {
    state.roles.unshift(rol)
    state.updatedData = rol;
}

export const setDeleteRol = (state, rol) => {
    state.rolesPaginatedData.data.filter(x => x.id !== rol.id);
    state.deletedData = rol
}

export const setRolIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setRolIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setRolIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setRolIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setRolProductsIsLoading = (state, isLoadingRolProducts) => {
    state.isLoadingRolProducts = isLoadingRolProducts
}

export const setRolProducts = (state, rolProducts) => {
    state.rolProducts = rolProducts
}